import {isIE} from "./detectIE";

export function newDate(dateString) {
    if(typeof dateString === 'number') return new Date(dateString);
    let string = dateString;
    if (isIE() && string.indexOf('+') >= 0) {
        string = string.slice(0, string.indexOf('+'));
    }
    return new Date(string);
}



// WEBPACK FOOTER //
// ./utilities/date.js